import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../../pages/home/home';
import { useAssessmentsDataContext } from '../../providers/assessments-data-provider';
import LoadingSpinner from '../common/loading-spinner';
import { useAuth } from '../../providers/auth-provider';
import SelfPaced from '../../pages/assessments/self-paced';
import WmAssessment from '../../pages/assessments/working-memory/wm-assessment';
import ReportsContainer from '../../pages/reports/reports-container';
import CandidateReportLink from '../../pages/reports/candidate-report-link';
import { LEADERSHIP_MANAGER } from '../../pages/reports/leader-reports';

function EmployeeRoutes() {
  const auth = useAuth();
  const [employeeLeader, setEmployeeLeader] = useState(false);
  const [displayAssessments, setDisplayAssessments] = useState(false);
  const { getAssessments, assessmentsRetrieved, userAssessmentsAssigned, userAssessmentsCompleted } =
    useAssessmentsDataContext();

  useEffect(() => {
    if (assessmentsRetrieved) {
      if (auth.isLeader()) {
        const assessmentsAssigned = userAssessmentsAssigned();
        const assessmentCompleted = userAssessmentsCompleted();
        if (assessmentsAssigned && !assessmentCompleted) {
          setDisplayAssessments(assessmentsAssigned);
        } else {
          setEmployeeLeader(true);
        }
      } else {
        setDisplayAssessments(true);
      }
    }
  }, [assessmentsRetrieved]);

  useEffect(() => {
    if (!assessmentsRetrieved) {
      getAssessments(auth);
    }
  }, [auth, getAssessments, assessmentsRetrieved]);

  return (
    <>
      {!assessmentsRetrieved && <LoadingSpinner />}
      {assessmentsRetrieved && (
        <Routes>
          <Route path="/*" element={<Home displayAssessments={displayAssessments} displayCompare={employeeLeader} />} />
          <Route path="/reports/:reference" element={<ReportsContainer reportType={LEADERSHIP_MANAGER} />} />
          <Route path="assessments/work-preferences" element={<SelfPaced type="work-preferences" time="20" />} />
          <Route path="/assessments/acumen" element={<WmAssessment />} />
          <Route path="/assessments/competencies/self" element={<SelfPaced type="self-competencies" time="4-7" />} />
          <Route
            path="/assessments/competencies/rater/:raterIndex"
            element={<SelfPaced type="rater-competencies" time="4-7" />}
          />
          <Route path="/client/:slug/reports-by-token/:token" element={<CandidateReportLink />} />
          <Route path="/client/:slug/reports-by-token/:token/:nonce" element={<CandidateReportLink />} />
        </Routes>
      )}
    </>
  );
}

export default EmployeeRoutes;
